//React
import { ReactNode } from 'react';
//hooks
import useLoader from '../hooks/useLoader';
//components
import LoadingScreen from './LoadingScreen';

type GeneralLoaderProps = {
    children : ReactNode
};

export default function GeneralLoader({ children } : GeneralLoaderProps)
{
    const { loading } = useLoader();
    return (
    <>
        {children}
        <LoadingScreen isDashboard={!loading} nested={true} />
    </>);
}